import { CombinationFilterOption } from './combination-filter-controls';

export function combinationFilterOptionIsVisible(
  option: CombinationFilterOption,
  selectedEnumValues: readonly string[] = []
): boolean {
  if (option.kind === 'range') {
    return option.min != null && option.max != null;
  }
  if (option.kind === 'enum') {
    return (
      option.values.length > 0 ||
      selectedEnumValues.some(
        (value) => !option.values.some((entry) => entry.value === value)
      )
    );
  }
  return option.trueCount + option.falseCount > 0;
}
